module.exports = __webpack_public_path__ + "media/packs/images/starred-shipment-a5eb93e878f19e9326681d7c5b5fea4e.svg";